// components/common/SearchInput.jsx
import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";

const SearchInput = ({
  placeholder = "Search",
  value,
  onChange,
  size = "small",
  sx = {},
  iconName = "search",
}) => {
  return (
    <TextField
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <ReusableMuiIcons name={iconName} />
          </InputAdornment>
        ),
      }}
      size={size}
      sx={{
        mb: { xs: 3, md: 0 },
        backgroundColor: "#F5F6FF",
        color: "#B5B5B5",
        ...sx,
      }}
    />
  );
};

export default SearchInput;
